import { Bell } from 'lucide-react';
import { Button } from '@ooh/ui/components/button';

export function NotificationBellButton({ label }: { label: string }) {
  return (
    <Button variant="ghost" size="icon" data-testid="notification-bell" aria-label={label}>
      <Bell className="h-4 w-4" strokeWidth={1.8} />
    </Button>
  );
}
